mod.modules.define("Quotes", "BaseModule", function(fn) {
	"use strict";

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.addPlugin("Plugin-Paging");
	};

	fn.prototype.events = {
		".quotes-controls-buttons button[data-action]:not(.active)" : {
			"click" : function(e, $el) {
				var action = $el.attr("data-action");

				this.reload({
					DaysOfHistory : action,
					PageIndex: 0
				});
			}
		},
		".quotes-controls-frequency select" : {
			"change" : function(e, $el) {
				this.reload({
					Frequency : $el.val(),
					PageIndex: 0
				});
			}
		}
	};

});